import { render, staticRenderFns } from "./academic_examination_reviveRank.vue?vue&type=template&id=3bef7980&scoped=true&"
import script from "./academic_examination_reviveRank.vue?vue&type=script&lang=js&"
export * from "./academic_examination_reviveRank.vue?vue&type=script&lang=js&"
import style0 from "./academic_examination_reviveRank.vue?vue&type=style&index=0&id=3bef7980&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bef7980",
  null
  
)

export default component.exports